import { PlayerSizesTypes } from '../../../common/store/store.types';
import { flexRowBetween, flexRowEnd } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { isEmpty } from '../../../common/utils/utils';
import { removeHighlights } from '../styles';
import { TOP_BAR_HEIGHTS } from '../controlsPlugin.constants';

interface StylesObject {
  topBarContainerStyle: { [key: string]: any };
  shareIconStyle: { [key: string]: any };
}

const topBarContainer = {
  ...flexRowBetween,
  ...removeHighlights,
  alignItems: 'center',
  width: '100%',
  position: 'absolute',
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundImage: SITE_VARIABLES.COLORS.GRADIENT_BLACK,
  pointerEvents: 'auto',
  transition: 'all ease-in-out 0.4s',
  opacity: 1,
  transform: 'translateY(0)',
  small: {
    backdropFilter: 'none',
    webkitBackdropFilter: 'none',
    backgroundImage: 'inherit',
    height: TOP_BAR_HEIGHTS.SMALL,
  },
  mediumAndLarge: {
    height: TOP_BAR_HEIGHTS.MEDIUM_AND_LARGE,
  },
  extraLarge: {
    height: TOP_BAR_HEIGHTS.EXTRA_LARGE,
  },
  adControls: {
    ...flexRowEnd,
    display: 'none',
  },
  splitView: {
    backdropFilter: 'none',
    webkitBackdropFilter: 'none',
    backgroundImage: 'inherit',
  },
  showCloseBar: {
    backdropFilter: 'none',
    webkitBackdropFilter: 'none',
    backgroundImage: 'inherit',
  },
  hide: {
    opacity: 0,
    small: {
      transform: `translateY(-${TOP_BAR_HEIGHTS.SMALL})`,
    },
    mediumAndLarge: {
      transform: `translateY(-${TOP_BAR_HEIGHTS.MEDIUM_AND_LARGE})`,
    },
    extraLarge: {
      transform: `translateY(-${TOP_BAR_HEIGHTS.EXTRA_LARGE})`,
    },
  },
};

const shareIcon = {
  color: SITE_VARIABLES.COLORS.WHITE,
  cursor: 'pointer',
  opacity: '0.7',
  display: 'flex',
  small: {
    display: 'none',
  },
  medium: {
    display: 'none',
  },
  large: {
    height: '16px',
    width: '16px',
    minWidth: '16px',
    marginRight: '8px',
  },
  extraLarge: {
    height: '20px',
    width: '20px',
    minWidth: '20px',
    marginRight: '16px',
  },
  hover: {
    opacity: '1',
  },
};

export const getTopBarStyleObject = (isVisible: boolean, playerSize: PlayerSizesTypes, showAdControls: boolean,
  splitViewRatio: number, showCloseBar: boolean, shareHovered?: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const mediumOrLarge = mediumSize || largeSize;
  const extraLargeSize = playerSize === 'extraLarge';
  const splitView = !isEmpty(splitViewRatio);

  return ({
    topBarContainerStyle: [
      topBarContainer,
      showAdControls && topBarContainer.adControls,
      smallSize && topBarContainer.small,
      mediumOrLarge && topBarContainer.mediumAndLarge,
      extraLargeSize && topBarContainer.extraLarge,
      splitView && topBarContainer.splitView,
      showCloseBar && topBarContainer.showCloseBar,
      !isVisible && topBarContainer.hide,
      !isVisible && smallSize && topBarContainer.hide.small,
      !isVisible && mediumOrLarge && topBarContainer.hide.mediumAndLarge,
      !isVisible && extraLargeSize && topBarContainer.hide.extraLarge,
    ],
    shareIconStyle: [
      shareIcon,
      shareHovered && shareIcon.hover,
      smallSize && shareIcon.small,
      mediumSize && shareIcon.medium,
      largeSize && shareIcon.large,
      extraLargeSize && shareIcon.extraLarge,
    ],
  });
};
